import { html, $ as $E, Page, on } from 'rune-ts';
import klass from './PlusShopLanding.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { BaseLayoutOptions } from '../../../features/Core/service';
import {
  MotionSection,
  BottomSection,
  PlusShopEditor,
  StatisticsSection,
  CaseSection,
  CommerceSection,
  ExhibitionSection,
  AdSection,
  SolutionSection,
  PortfolioSection,
  PlusShopEditorClosed,
} from './views';
import { LandingHeader, RANDING_HEADER_MENUS } from '../../components/cells/LandingHeader/LandingHeader';
import { find } from '@fxts/core';

import { isFixedElementInSection } from '../../../shared/util/elementPositionHelper';
import { ButtonCtaLanding } from '../../../shared/components/atoms/ButtonCtaLanding/ButtonCtaLanding';

export interface PlusShopLandingData {
  layout_options: BaseLayoutOptions;
}

export class PlusShopLandingPage extends Page<PlusShopLandingData> {
  motionSection = new MotionSection();
  bottomSection = new BottomSection();
  statisticsSection = new StatisticsSection();
  caseSection = new CaseSection();
  commerceSection = new CommerceSection();
  exhibitionSection = new ExhibitionSection();
  adSection = new AdSection();
  solutionSection = new SolutionSection();
  portfolioSection = new PortfolioSection();
  ctaButton = new ButtonCtaLanding({
    type: 'white',
    label: ET('mps2::landing::plus::submit'),
    klass: `${klass.submit} submit`,
  });

  protected override template() {
    const { layout_options } = this.data;
    const { is_mobile } = layout_options;

    const current_menu = find((menu) => {
      return menu.name === 'Plus';
    }, RANDING_HEADER_MENUS);

    const body = html`
      <div class="${klass.container}">
        <!--   헤더     -->
        ${current_menu
          ? new LandingHeader({
              current_menu,
              is_mobile,
            })
          : ``}

        <!--   video 모션 섹션     -->
        ${this.motionSection}

        <!--    statistics 섹션    -->
        ${this.statisticsSection}

        <!--    case 섹션    -->
        ${this.caseSection}

        <!--    commerce 섹션    -->
        ${this.commerceSection}

        <!--    exhibition 섹션    -->
        ${this.exhibitionSection}

        <!--    ad 섹션    -->
        ${this.adSection}

        <!--    solution 섹션    -->
        ${this.solutionSection}

        <!--    portfolio 섹션    -->
        ${this.portfolioSection}

        <!--    바텀 섹션    -->
        ${this.bottomSection}

        <!--    cta 버튼    -->
        ${this.ctaButton}
      </div>
    `;

    return html`
      <div>
        ${new LayoutView(
          {
            body,
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            require_top_arrow_button: false,
            full_width: true,
            has_bottom_tab_bar: false,
            selected_bottom_tab_idx: -1,
            ...layout_options,
          },
        )}
      </div>
    `;
  }

  openEditor() {
    const el = this.element();

    el.classList.add(klass.editing);
    document.querySelector('html, body')?.scrollTo(0, 0);

    el.after(
      new PlusShopEditor(this.data)
        .addEventListener(PlusShopEditorClosed, () => {
          el.classList.remove(klass.editing);
        })
        .render(),
    );
  }

  handleScrollChangeButtonColor() {
    if (this.ctaButton.isRendered()) {
      const $current_section = $E(this.element())
        .findAll(`.${klass.container} > section`)
        .find(($section) => isFixedElementInSection(this.ctaButton.element(), $section.element()));

      if ($current_section) {
        switch ($current_section.element()) {
          case this.motionSection.element():
          case this.commerceSection.element():
          case this.exhibitionSection.element():
          case this.adSection.element():
            this.ctaButton.setTypeOption('white');
            break;
          case this.solutionSection.element():
          case this.portfolioSection.element():
          case this.statisticsSection.element():
          case this.caseSection.element():
            this.ctaButton.setTypeOption('blue');
            break;
          case this.bottomSection.element():
            this.ctaButton.setTypeOption('hidden');
            break;
          default:
            break;
        }
      }
    }
  }

  override onRender() {
    this.handleScrollChangeButtonColor();

    document.addEventListener('scroll', () => this.handleScrollChangeButtonColor(), {
      passive: true,
    });

    if (window.visualViewport) {
      window.visualViewport.onresize = () => this.handleScrollChangeButtonColor();
    }
  }

  @on('click', `.submit`)
  onClickSubmitButton() {
    this.openEditor();
  }
}
